import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import establishmentReducer from './slices/Establishment'

/**
 * Redux store configuration
 * This store is configured with the establishment slice.
 */
export const store = configureStore({
  reducer: {
    establishment: establishmentReducer
  }
})

/**
 * RootState type
 * This type represents the state of the Redux store.
 */
export type RootState = ReturnType<typeof store.getState>

/**
 * AppDispatch type
 * This type represents the dispatch function of the Redux store.
 */
export type AppDispatch = typeof store.dispatch

/** Custom hooks for using the Redux store
 * These hooks provide a typed version of useDispatch and useSelector.
 * @returns {AppDispatch} - A typed version of useDispatch
 */
export const useAppDispatch: () => AppDispatch = useDispatch

/** useAppSelector hook
 * This hook provides a typed version of useSelector for accessing the Redux store state.
 * @returns {TypedUseSelectorHook<RootState>} - A typed version of useSelector
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
